import { twMerge } from "tailwind-merge";

type BigDataChartProps = {
  value: number;
  type: "MAX" | "AVG" | "MIN" | "MEDIAN";
};

const findItemsValue = (type: string) => {
  const items = [
    {
      label: "Max. Score",
      color: "bg-solid-green",
      type: "MAX"
    },
    {
      label: "Avg. Score",
      color: "bg-tangerine",
      type: "AVG"
    },
    {
      label: "Min. Score",
      color: "bg-solid-red",
      type: "MIN"
    },
    {
      label: "Median. Score",
      color: "bg-solid-blue",
      type: "MEDIAN"
    }
  ];
  return items.find((item) => item.type === type);
};

export default function BigDataChart({
  value,
  type
}: Readonly<BigDataChartProps>) {
  return (
    <div
      className={twMerge(
        `bg-white flex rounded-xl py-2 px-3 gap-3 border border-gainsboro w-full max-w-[400px]`
      )}
    >
      <div
        className={twMerge(
          `w-1 self-stretch rounded-full shrink-0`,
          findItemsValue(type)?.color
        )}
      />
      <div className="flex flex-col">
        <p className="text-txtBody text-xs font-semibold">
          {findItemsValue(type)?.label}
        </p>
        <p className="text-primary-teal text-2xl font-semibold">
          {value.toLocaleString("en-US", {
            maximumFractionDigits: 3
          })}
        </p>
      </div>
    </div>
  );
}
